export default __webpack_public_path__ + "static/media/Le Regole.57246740.png";